import { memo } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '@mui/material/IconButton';
import { WebRoutes } from "consts/enpoints/web";
import { Navigate } from "infrastructure/router";
import {
    BusinessInformationLabel,
    DirectorsAndShareholdersLabel,
    FinancialInformationLabel,
    PaymentMethodsLabel,
    RiskAndComplianceLabel,
    MarketingWebsiteAndSupportLabel,
    UploadDocumentsLabel,
    Complete
} from "./steps";
import { Stats, OnboardingLayout } from "../common";
import { useOnboardingApplication } from "./hooks";

const OnboardingComplete = () => {
    const {
        isApplicationCompleted,
        isApplicationSubmitted,
        getApplicationModel
    } = useOnboardingApplication();

    switch (true) {
        // Appication is submitted and completed, redirect to home page
        case (
            isApplicationSubmitted() &&
            isApplicationCompleted()
        ): {
                return (
                    <Navigate
                        to={WebRoutes.Root}
                        replace
                    />
                );
            }

        // Application is not submitted, but completed, show complete step
        case (
            !isApplicationSubmitted() &&
            isApplicationCompleted()
        ): {
                return (
                    <OnboardingLayout>
                        <Complete
                            slots={{
                                stats: (
                                    <Stats
                                        sx={{
                                            color: 'primary.main'
                                        }}
                                        route={WebRoutes.Onboarding.HighRiskMerchant}
                                        getApplicationModel={getApplicationModel}
                                    />
                                )
                            }}
                        >
                            {[
                                BusinessInformationLabel,
                                DirectorsAndShareholdersLabel,
                                FinancialInformationLabel,
                                PaymentMethodsLabel,
                                RiskAndComplianceLabel,
                                MarketingWebsiteAndSupportLabel,
                                UploadDocumentsLabel
                            ].map((Component, index) => (
                                <Component
                                    key={index}
                                    sx={{
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 1,
                                        px: 2,
                                        py: 1
                                    }}
                                    endAdornment={(
                                        <IconButton
                                            color='secondary'
                                            onClick={event => event.preventDefault()}
                                            sx={{
                                                pointerEvents: 'none'
                                            }}
                                        >
                                            <CheckCircleIcon />
                                        </IconButton>
                                    )}
                                />
                            ))}
                        </Complete>
                    </OnboardingLayout>
                );
            }

        // For rest of the cases, redirect to onboarding index (Getting Started), that guy will handle the rest ;)
        default: {
            return (
                <Navigate
                    to={WebRoutes.Onboarding.HighRiskMerchant.Index}
                    replace
                />
            );
        }
    }
};

export default memo(OnboardingComplete);
